import React from 'react';
import StarIcon from '@mui/icons-material/Star';
export function StatsBar() {
  return <div className="bg-brand-dark text-white py-8" data-id="element-340">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-341">
        <h3 className="text-center text-brand-gold font-serif text-xl mb-5 tracking-widest uppercase" data-id="element-342">
          Números que hablan
        </h3>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-343">
          <div className="flex flex-col items-center" data-id="element-344">
            <span className="text-4xl md:text-5xl font-bold font-serif mb-2" data-id="element-345">
              +500
            </span>
            <span className="text-sm md:text-base text-gray-300" data-id="element-346">
              emprendedoras confían
            </span>
          </div>

          <div className="flex flex-col items-center" data-id="element-347">
            <span className="text-4xl md:text-5xl font-bold font-serif mb-2" data-id="element-348">
              2
            </span>
            <span className="text-sm md:text-base text-gray-300" data-id="element-349">
              Tomos completos
            </span>
          </div>

          <div className="flex flex-col items-center" data-id="element-350">
            <span className="text-4xl md:text-5xl font-bold font-serif mb-2" data-id="element-351">
              3
            </span>
            <span className="text-sm md:text-base text-gray-300" data-id="element-352">
              Bonos incluidos
            </span>
          </div>

          <div className="flex flex-col items-center" data-id="element-353">
            <div className="flex items-center justify-center gap-1 mb-2" data-id="element-354">
              <span className="text-4xl md:text-5xl font-bold font-serif" data-id="element-355">
                4.9
              </span>
              <span className="text-2xl text-brand-gold" data-id="element-356">/5</span>
            </div>
            <div className="flex text-brand-gold mb-1" data-id="element-357">
              {[...Array(5)].map((_, i) => <StarIcon key={i} fontSize="small" data-id="element-358" />)}
            </div>
            <span className="text-sm md:text-base text-gray-300" data-id="element-359">
              calificación
            </span>
          </div>
        </div>
      </div>
    </div>;
}